import { TransactionFlag } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';
import { hasFlag } from './hasFlag';

export const hasVoucher: TransactionPredicate = hasFlag(
    TransactionFlag.HAS_VOUCHER,
    TransactionFlag.HAS_IMAGE,
);
